import * as tslib_1 from "tslib";
import { BaseManager } from "./base.manager";
import { LocalStorageRepositoryInterface } from "../../datastore/local/localstorage.interface";
import { NurseryRepositoryInterface } from "../../datastore/repositories/nursery/nursery.interface";
import { of } from "rxjs";
import { catchError, concatMap, map } from "rxjs/operators";
import { MediaRepositoryInterface } from "../../datastore/repositories/media/media.interface";
var NurseryManager = /** @class */ (function (_super) {
    tslib_1.__extends(NurseryManager, _super);
    function NurseryManager(localStorageRepository, nurseryRepository, mediaRepository) {
        var _this = _super.call(this, localStorageRepository) || this;
        _this.localStorageRepository = localStorageRepository;
        _this.nurseryRepository = nurseryRepository;
        _this.mediaRepository = mediaRepository;
        return _this;
    }
    NurseryManager.prototype.getNursery = function (uuid) {
        var _this = this;
        return this.nurseryRepository.getNursery(uuid)
            .pipe(concatMap(function (nursery) { return _this.getNurseryMedia(nursery); }));
    };
    NurseryManager.prototype.getNurseryMedia = function (nursery, quality) {
        if (quality === void 0) { quality = "view_fhd"; }
        return this.mediaRepository.getMediasByEntity("search=custom_tag:nursery_cover_image", nursery.uuid)
            .pipe(map(function (_a) {
            var _ = _a[0], media = _a[1];
            if (media && media.length > 0) {
                nursery.imageURL = media[0].getMediaURL(quality);
            }
            return nursery;
        }), catchError(function () {
            return of(nursery);
        }));
    };
    NurseryManager.prototype.getNurseries = function (visible, pageSize, page) {
        return this.nurseryRepository.getNurseries(visible, pageSize, page);
    };
    NurseryManager.prototype.editNursery = function (id, body) {
        return this.nurseryRepository.editNursery(id, body).pipe();
    };
    NurseryManager.prototype.addNursery = function (body) {
        return this.nurseryRepository.addNursery(body).pipe();
    };
    NurseryManager.prototype.deleteNursery = function (id) {
        return this.nurseryRepository.deleteNursery(id).pipe();
    };
    NurseryManager.prototype.duplicateNursery = function (nurseryUUID) {
        return this.nurseryRepository.duplicateNursery(nurseryUUID).pipe();
    };
    NurseryManager.prototype.addNurserySpheres = function (body, nurseryUUID) {
        var formData = new FormData();
        for (var _i = 0, body_1 = body; _i < body_1.length; _i++) {
            var file = body_1[_i];
            formData.append("files", file);
        }
        return this.nurseryRepository.addPhotospheres(formData, nurseryUUID);
    };
    NurseryManager.prototype.connectSpheres = function (nurseryUUID) {
        return this.nurseryRepository.connectPhotospheres(nurseryUUID);
    };
    NurseryManager.prototype.addNurseryCSV = function (body, nurseryUUID) {
        var formData = new FormData();
        for (var _i = 0, body_2 = body; _i < body_2.length; _i++) {
            var file = body_2[_i];
            formData.append("file", file);
        }
        return this.nurseryRepository.addCSV(formData, nurseryUUID);
    };
    /* eslint-disable camelcase, @typescript-eslint/camelcase */
    NurseryManager.prototype.getPolygons = function (pageSize, page, nurseryUUID) {
        return this.nurseryRepository.getPolygons(pageSize, page, nurseryUUID);
    };
    NurseryManager.prototype.addPolygon = function (polygon, productUUID, nurseryUUID, productInfo) {
        var geofences = [];
        polygon.getPath().forEach(function (latLng, index) {
            geofences.push({
                latitude: latLng.lat(),
                longitude: latLng.lng(),
                index: index
            });
        });
        var polyType = {
            geofences: geofences,
            nursery_uuid: nurseryUUID,
            product_id_cod: productUUID,
            product_info: productInfo
        };
        return this.nurseryRepository.addPolygon(polyType);
    };
    NurseryManager.prototype.editPolygon = function (polygonUUID, productUUID, productInfo) {
        var polygon = {
            product_id_cod: productUUID,
            nursery_uuid: undefined,
            geofences: undefined,
            product_info: productInfo
        };
        return this.nurseryRepository.editPolygon(polygonUUID, polygon);
    };
    NurseryManager.prototype.deletePolygon = function (polygonUUID) {
        return this.nurseryRepository.deletePolygon(polygonUUID);
    };
    NurseryManager.prototype.getShortcuts = function (pageSize, page, nurseryUUID) {
        return this.nurseryRepository.getShortcuts(pageSize, page, nurseryUUID);
    };
    NurseryManager.prototype.addShortcut = function (shortcut) {
        return this.nurseryRepository.addShortcut(shortcut);
    };
    NurseryManager.prototype.editShortcut = function (shortcutUUID, shortcut) {
        return this.nurseryRepository.editShortcut(shortcutUUID, shortcut);
    };
    NurseryManager.prototype.deleteShortcut = function (shortcutUUID) {
        return this.nurseryRepository.deleteShortcut(shortcutUUID);
    };
    return NurseryManager;
}(BaseManager));
export { NurseryManager };
